import { useEffect, useRef } from "react";
import { auth, db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import { useNotifications } from "../hooks/notificationsContext";

export function useGoldMinter() {
  const { addNotification } = useNotifications();
  const timeoutRef = useRef(null);

  useEffect(() => {
    let cancelled = false;
    const eightHoursMs = 8 * 60 * 60 * 1000;

    const scheduleNextCheck = async () => {
      if (cancelled) return;

      try {
        const user = auth.currentUser;
        if (!user) return;

        const uid = user.uid;
        const token = await user.getIdToken(true);

        const userDoc = await getDoc(doc(db, "Users", uid));
        if (!userDoc.exists()) return;

        const userData = userDoc.data();
        const lastMinted = userData.userGoldReceivedAt || 0;
        const now = Date.now();
        const timeSinceLast = now - lastMinted;

        if (timeSinceLast >= eightHoursMs) {
          // Mint gold
          const res = await fetch("https://mintgold-5dhfwyjvzq-uc.a.run.app", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ uid }),
          });

          if (!res.ok) {
            const err = await res.json();
            addNotification(`Failed to mint gold: ${err.error}`, "error");
          } else {
            const data = await res.json();
            if (data.success && !cancelled) {
              addNotification(`You minted ${data.goldMinted} gold.`, "success");
            }
          }
          // Schedule next check 8 hours from now
          timeoutRef.current = setTimeout(scheduleNextCheck, eightHoursMs);
        } else {
          // Schedule the check for remaining time until 8h passed
          timeoutRef.current = setTimeout(scheduleNextCheck, eightHoursMs - timeSinceLast);
        }
      } catch (err) {
        console.error("❌ Mint gold error:", err);
        if (!cancelled) addNotification("An error occurred while minting gold.", "error");
        // Retry in 10 minutes on error
        timeoutRef.current = setTimeout(scheduleNextCheck, 10 * 60 * 1000);
      }
    };

    scheduleNextCheck();

    return () => {
      cancelled = true;
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [addNotification]);
}
